import { render, staticRenderFns } from "./external.vue?vue&type=template&id=21019b3a&scoped=true"
import script from "./external.vue?vue&type=script&lang=js"
export * from "./external.vue?vue&type=script&lang=js"
import style0 from "./external.vue?vue&type=style&index=0&id=21019b3a&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21019b3a",
  null
  
)

export default component.exports